import React from 'react';
import { connect } from 'react-redux';
import findResult from '@/utils/resultsHelper';
import { visibilityIcon } from '@/constants/images';
import { states } from '@/constants/lifecycle';
import ToggleRow from '@/components/table/ToggleRow';
import CohortSettingVisibilityWarning from '../components/CohortSettingVisibilityWarning';
import DatasetCohortMinValueSettingRow from '../components/DatasetCohortMinValueSettingRow';
import { datasetSettingsFields } from '../state/state';
import { datasetManagePermissions } from '../../sharing/constants';
import { showEditCohortSettings, toggleDatasetSetting } from '../actions';
import { datasetPerms } from '../../sharing/state/state';

const DatasetCohortSettingRows = ({
  category,
  code,
  allowPrivateCohorts,
  allowInternalCohorts,
  exposeCohortCounts,
  exposeCohortVisualisations,
  minCohortSize,
  cohortAccessAllowed,
  canChangeSettings,
  name,
  toggleSetting,
  showCohortSettings,
}) => (
  <>
    {!cohortAccessAllowed && (<CohortSettingVisibilityWarning />)}
    <ToggleRow
      context="dataset.setting"
      label="allow_private_cohorts"
      icons={[visibilityIcon.private]}
      message="dataset.settings.cohort.allow.private"
      checked={allowPrivateCohorts}
      onClick={() => toggleSetting(category, code, 'allow_private_cohorts', name)}
      disabled={!canChangeSettings}
      entity="cohort"
      labelWidth={14}
    />
    <ToggleRow
      context="dataset.setting"
      label="allow_internal_cohorts"
      icons={[visibilityIcon.internal]}
      message="dataset.settings.cohort.allow.internal"
      checked={allowInternalCohorts}
      onClick={() => toggleSetting(category, code, 'allow_internal_cohorts', name)}
      disabled={!canChangeSettings}
      entity="cohort"
      labelWidth={14}
    />
    <ToggleRow
      context="dataset.setting"
      label="expose_cohort_counts"
      icons={['calculator']}
      message="dataset.settings.cohort.expose.counts"
      checked={exposeCohortCounts}
      onClick={() => toggleSetting(category, code, 'expose_cohort_counts', name)}
      disabled={!canChangeSettings}
      entity="cohort"
      labelWidth={14}
    />
    <ToggleRow
      context="dataset.setting"
      label="expose_cohort_visualisations"
      icons={['chart bar']}
      message="dataset.settings.cohort.expose.visualisations"
      checked={exposeCohortVisualisations}
      onClick={() => toggleSetting(category, code, 'expose_cohort_visualisations', name)}
      disabled={!canChangeSettings}
      entity="cohort"
      labelWidth={14}
    />
    <DatasetCohortMinValueSettingRow
      value={minCohortSize}
      labelWidth={14}
      canEdit={canChangeSettings}
      showEdit={() => showCohortSettings(category, code, name)}
    />
  </>
);

const mapStateToProps = ({
  datasetSettings: { settings },
  datasetUsers: { permissions },
}, { category, code }) => {
  const perms = findResult(permissions, category, code) || datasetPerms();
  const item = findResult(settings, category, code) || datasetSettingsFields();

  return ({
    allowInternalCohorts: item.allow_internal_cohorts,
    allowPrivateCohorts: item.allow_private_cohorts,
    canChangeSettings: item.saveStatus !== states.PENDING && perms[datasetManagePermissions.SETTINGS],
    cohortAccessAllowed: item.allow_private_cohorts || item.allow_internal_cohorts,
    exposeCohortCounts: item.expose_cohort_counts,
    exposeCohortVisualisations: item.expose_cohort_visualisations,
    minCohortSize: item.minimum_cohort_size,
  });
};

const mapDispatchToProps = {
  toggleSetting: toggleDatasetSetting,
  showCohortSettings: showEditCohortSettings,
};

export default connect(mapStateToProps, mapDispatchToProps)(DatasetCohortSettingRows);
